export default "__VITE_ASSET__7rfNasWM__"